import React from 'react';
import classnames from 'classnames';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import { Price } from 'swag-client-common/utils/price';
import classes from './pricing-formation-details-popup.scss';
const Content = ({
  orderItems,
  blendedTotalOrderPrice,
  saving,
  isLimitedEdition
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.flexContent
}, /*#__PURE__*/React.createElement("p", {
  className: classes.description
}, "Congrats! Because you are printing the same design on several associated products, you are saving money on all of the printing fees and set up costs."), /*#__PURE__*/React.createElement("ul", {
  className: classes.orderItemsList
}, orderItems.map(item => /*#__PURE__*/React.createElement("li", {
  "data-row": item.prodId,
  key: item.prodId,
  className: classes.orderItem
}, /*#__PURE__*/React.createElement("div", {
  className: classes.productInfoContainer
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
  src: item.logo,
  className: classes.productImage
})), /*#__PURE__*/React.createElement("div", {
  className: classes.productInfo
}, /*#__PURE__*/React.createElement("div", {
  className: classes.secondaryText,
  "data-text": "Name"
}, item.title), /*#__PURE__*/React.createElement("div", {
  className: classes.secondaryText
}, "Quantity:", ' ', /*#__PURE__*/React.createElement("span", {
  className: classes.quantity,
  "data-text": "Quantity"
}, item.quantity)))), /*#__PURE__*/React.createElement("div", {
  className: classes.pricing
}, /*#__PURE__*/React.createElement("span", {
  className: classes.secondaryText
}, "Per item:", ' ', /*#__PURE__*/React.createElement("span", {
  className: classnames(classes.price, classes.oldPrice, {
    [classes.orangeCross]: isLimitedEdition
  }),
  "data-text": "OldItemPrice"
}, Price.formatPrice((item.price - item.setupFee) / item.quantity))), /*#__PURE__*/React.createElement("span", {
  className: classes.secondaryText
}, "Blended item price:", ' ', /*#__PURE__*/React.createElement("span", {
  className: classnames(classes.price, {
    [classes.orangeColor]: isLimitedEdition
  }),
  "data-text": "BlendedItemPrice"
}, Price.formatPrice((item.blendedPrice - item.setupFee) / item.quantity))), /*#__PURE__*/React.createElement("span", {
  className: classes.secondaryText
}, "Shared setup fee:", ' ', /*#__PURE__*/React.createElement("span", {
  className: classnames(classes.price, {
    [classes.orangeColor]: isLimitedEdition
  }),
  "data-text": "SharedSetupFee"
}, Price.formatPrice(item.setupFee))))))), /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.pricing, classes.orderTotals)
}, /*#__PURE__*/React.createElement("span", {
  className: classes.secondaryText
}, "Total blended:", ' ', /*#__PURE__*/React.createElement("span", {
  className: classnames(classes.price, {
    [classes.orangeColor]: isLimitedEdition
  }),
  "data-text": "TotalPrice"
}, Price.formatPrice(blendedTotalOrderPrice))), /*#__PURE__*/React.createElement("span", {
  className: classes.secondaryText
}, "You save:", /*#__PURE__*/React.createElement("span", {
  className: classnames(classes.price, classes.saving, {
    [classes.orangeColor]: isLimitedEdition
  }),
  "data-text": "Savings"
}, Price.formatPrice(saving)))));
export const PricingFormationDetailsPopupComponent = ({
  orderItems,
  blendedTotalOrderPrice,
  saving,
  isLimitedEdition,
  onClose
}) => /*#__PURE__*/React.createElement(InfoDialog, {
  dataPopup: "AssociatedPricingBreakdown",
  header: "See where you save money",
  content: /*#__PURE__*/React.createElement(Content, {
    orderItems: orderItems,
    blendedTotalOrderPrice: blendedTotalOrderPrice,
    saving: saving,
    isLimitedEdition: isLimitedEdition
  }),
  onRequestClose: onClose,
  contentClassName: classes.popupContent,
  contentWrapperClassName: classes.contentWrapper,
  titleContentClass: isLimitedEdition ? classes.orangeSubHeader : '',
  closeButtonClassName: isLimitedEdition ? classes.orangeBackground : '',
  showCloseButton: true,
  open: true
});